import './App.css';
import Header from './Components/Header';
import Banner from './Components/Banner';
import HomeBox1 from './Components/Home-box1';
import HomeBox2 from './Components/Home-box2';
import HomeBox3 from './Components/Home-box3';
import HomeBox4 from './Components/Home-box4';
import CounterSection from './Components/Counter-section';
import HomeBox5 from './Components/Home-box5';
import ToolsSection from './Components/Tools-section';
import HomeBox6 from './Components/Home-box6';
// import CompanyLogoSlider from './Components/COmpany-logo-slider';
import HomeBox7 from './Components/Home-box7';
import HomeBox8 from './Components/Home-box8';
import HomeBox9 from './Components/Home-box9';
import HomeBox10 from './Components/Home-box10';
import HomeBox11 from './Components/Home-box11';
import HomeBox14 from './Components/Home-box14';
import HomeBox12 from './Components/Home-box12';
// import QNA from './Components/QNA';
import HomeBox13 from './Components/Home-box13';
import Footer from './Components/Footer';
import CardFeature from './Components/carddesignFeatures/CardFeature';
import Webfeature from './Components/Webstamper/Webfeature';
import Customerfeature from './Components/CustomerSharing&Enrollment/Customerfeature';
import CustomerManagementfeature from './Components/CustomerManagement/CustomerManagementfeature';
import StaffManagementfeature from './Components/StaffManagement/StaffManagementfeature';
import ReviewFeature from './Components/ReviewsFeatures/ReviewFeature';
import Pricing from './Pricing';
import FAQ from './FAQ';
import ScrollToHash from './Components/ScrollToHash';

import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import FAQHeader from './Components/FAQ-header';

function AnimateHomebox2main() {
  const location = useLocation();

  useEffect(() => {
    const nodes = Array.from(document.querySelectorAll('.homebox2main'));
    if (!nodes.length) return;

    const observer = new IntersectionObserver(
      (entries, obs) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('homebox2-visible');
            obs.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.4 }
    );

    nodes.forEach((node) => observer.observe(node));

    return () => observer.disconnect();
  }, [location.pathname]);

  return null;
}

function App() {
  return (
    <Router>
      <ScrollToHash />
      <AnimateHomebox2main />

      <Routes>
        {/* Home Page */}

        <Route
          path="/"
          element={
            <>
              <Header />
              <Banner />
              <HomeBox1 />
              <HomeBox2 />
              <HomeBox3 />
              <HomeBox4 />
              <CounterSection />
              <HomeBox5 />
              <ToolsSection />
              <HomeBox6 />
              {/* <CompanyLogoSlider /> */}
              <HomeBox7 />
              <HomeBox8 />
              <HomeBox9 />
              <HomeBox10 />
              <HomeBox11 />
              <HomeBox14 />
              <HomeBox12 />
              {/* <QNA /> */}
              <HomeBox13 />
            </>
          }
        />

        <Route
          path="/card-design-feature"
          element={
            <>
              <FAQHeader />
              <CardFeature />
            </>
          }
        />

        <Route
          path="/web-stamper-feature"
          element={
            <>
              <FAQHeader />
              <Webfeature />
            </>
          }
        />

        <Route
          path="/customersharing-feature-box1"
          element={
            <>
              <FAQHeader />
              <Customerfeature />
            </>
          }
        />

        <Route
          path="/customermanagement-feature-box1"
          element={
            <>
              <FAQHeader />
              <CustomerManagementfeature />
            </>
          }
        />

        <Route
          path="/staffmanagement-feature-box1"
          element={
            <>
              <FAQHeader />
              <StaffManagementfeature />
            </>
          }
        />

        <Route
          path="/Reviewfeature"
          element={
            <>
              <FAQHeader />
              <ReviewFeature />
            </>
          }
        />


        {/* Pricing Page */}
        <Route path="/pricing" element={<Pricing />} />

        {/* FAQ Page */}
        <Route path="/faq" element={<FAQ />} />
      </Routes>

      <Footer />
    </Router>
  );
}

export default App;